import { render, staticRenderFns } from "./ContactRelationshipMenu.vue?vue&type=template&id=0560e7b4&scoped=true"
import script from "./ContactRelationshipMenu.vue?vue&type=script&lang=js"
export * from "./ContactRelationshipMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560e7b4",
  null
  
)

export default component.exports